import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysAutoCancelOrderMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { sysAutoCancelOrderContent: { tradeId } = {} } = raw;

  if (tradeId) {
    return (
      <SystemMessage>
        {t('scene.chatWorkspace.messageThread.systemMessage.autoCancelOrderApproved', { tradeId })}
      </SystemMessage>
    );
  }

  return null;
});
